module.exports = __webpack_public_path__ + "img/0324image3.4755064a.png";